import { getStatusLabel, getStatusColor } from "~/utils/status";
import Title from "~/shared/Title";
import IndicatorBall from "./IndicatorBall";

type StatusIndicatorProps = {
    statusName: string;
    small?: boolean;
    withoutIndicator?: boolean;
};

const StatusIndicator = ({ statusName, withoutIndicator = false, small = false }: StatusIndicatorProps) => {
    const color = getStatusColor(statusName);
    const label = getStatusLabel(statusName);

    if (small) {
        return (
            <p style={{ color, fontWeight: "bold", textAlign: "right", margin: "8px 0" }}>
                {label} {withoutIndicator ? "" : <IndicatorBall small color={color} />}
            </p>
        );
    }

    return (
        <Title level="3" color={color}>
            {withoutIndicator ? "" : <><IndicatorBall color={color} />{" "}</>}{label}
        </Title>
    );
};

export default StatusIndicator;
